import { render, staticRenderFns } from "./public-documents.vue?vue&type=template&id=181e3e75&"
import script from "./public-documents.vue?vue&type=script&lang=js&"
export * from "./public-documents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports